import { create } from 'zustand';

type ImpactPlusRegisterHeaderState = {
  registerSearchQuery: string;
  setRegisterSearchQuery: (q: string) => void;
  createNewHandler: (() => void | Promise<void>) | null;
  setCreateNewHandler: (fn: (() => void | Promise<void>) | null) => void;
};

export const ImpactPlusRegisterHeaderStore = create<ImpactPlusRegisterHeaderState>((set) => ({
  registerSearchQuery: '',
  setRegisterSearchQuery: (q) => set({ registerSearchQuery: q }),
  createNewHandler: null,
  setCreateNewHandler: (fn) => set({ createNewHandler: fn }),
}));
